<div class="functii-multiple-container">
    <form class="functii-multiple-form d-flex flex-column" [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- <h1 class="dialog-title">
            <mat-icon>work_outline</mat-icon>
            Actualizare Funcții Multiple - {{ data.name }}
        </h1> -->

        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-section">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Se încarcă funcțiile...</p>
        </div>

        <!-- Main content -->
        <div *ngIf="!isLoading" class="form-content flex-grow-1">

            <!-- Functions Selection Section -->
            <mat-card class="functions-selection-card">
                <mat-card-header>
                    <mat-card-title>
                        <mat-icon>assignment</mat-icon>
                        Selectare Funcții - {{ data.name }}
                    </mat-card-title>
                    <mat-card-subtitle>
                        Selectați funcțiile pe care le poate îndeplini acest operator
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="functions-list" formArrayName="functions">
                        <div *ngFor="let function of availableFunctions; let i = index" class="function-item"
                            [class.function-assigned]="hasCurrentFunction(function.id)"
                            [class.function-active]="getCurrentFunctionStatus(function.id) === 'Activă'">

                            <mat-checkbox [formControlName]="i" (change)="onFunctionSelectionChange()"
                                class="function-checkbox" color="primary">
                                {{ function.name }} <span *ngIf="!function.active" class="ms-2"
                                    style="color: red;">Dezactivată</span>
                            </mat-checkbox>

                            <div class="function-status">
                                <mat-chip [color]="getCurrentFunctionStatus(function.id) === 'Activă' ? 'primary' : 
                                           getCurrentFunctionStatus(function.id) === 'Alocată' ? 'accent' : 'basic'"
                                    size="small">
                                    {{ getCurrentFunctionStatus(function.id) }}
                                </mat-chip>
                            </div>
                        </div>
                    </div>

                    <div class="selection-summary">
                        <mat-icon>info</mat-icon>
                        <span>
                            {{ getSelectedFunctionsCount() }}
                            {{ getSelectedFunctionsCount() === 1 ? 'funcție selectată' : 'funcții selectate' }}
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Active Function Selection -->
            <mat-card class="active-function-card" *ngIf="getSelectedFunctionsCount() > 0">
                <mat-card-header>
                    <mat-card-title>
                        <mat-icon>star</mat-icon>
                        Funcția Activă
                    </mat-card-title>
                    <mat-card-subtitle>
                        Selectați care funcție va fi activă în mod implicit
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Funcție Activă</mat-label>
                        <mat-select formControlName="activeFunctie">
                            <mat-option *ngFor="let function of getAvailableActiveFunctions()" [value]="function.id">
                                {{ function.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('activeFunctie')?.hasError('required')">
                            Trebuie să selectați o funcție activă
                        </mat-error>
                    </mat-form-field>

                    <div class="active-function-info">
                        <mat-icon>lightbulb</mat-icon>
                        <span>
                            Funcția activă va fi afișată în navbar și va fi utilizată în mod implicit
                        </span>
                    </div>
                </mat-card-content>
            </mat-card>

            <!-- Instructions Card -->
            <mat-card class="instructions-card">
                <mat-card-content>
                    <div class="instructions">
                        <h4><mat-icon>help_outline</mat-icon> Instrucțiuni:</h4>
                        <ul>
                            <li>Selectați toate funcțiile pe care le poate îndeplini operatorul</li>
                            <li>Alegeți o funcție activă care va fi utilizată în mod implicit</li>
                            <li>Operatorul poate schimba funcția activă din navbar</li>
                            <li>Cel puțin o funcție trebuie să fie selectată</li>
                        </ul>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="row m-3">
            <div class="col d-flex justify-content-between">
                <button class="btn btn-light" type="button" mat-flat-button (click)="closeDialog()"
                    [disabled]="isSubmitting">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>

                <button class="btn btn-primary" type="submit" mat-flat-button color="primary"
                    [disabled]="isSubmitting || isFormInvalid()">
                    <mat-icon *ngIf="!isSubmitting">save</mat-icon>
                    <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
                    {{ isSubmitting ? 'Se salvează...' : helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>

        <!-- Loading overlay for submission -->
        <div class="loading-overlay" *ngIf="isSubmitting">
            <div class="spinner-container">
                <mat-spinner diameter="50"></mat-spinner>
                <h3 class="mt-2">Se actualizează funcțiile...</h3>
            </div>
        </div>
    </form>
</div>